import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_METODOS_PAGO_ABONOS_BASE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.metodos-pago-abonos-abase'), data).then(res => {
                commit('setListaActiva', res.data.lista);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_METODOS_PAGO_EVENTOS: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.metodos-pago-eventos'), data).then(res => {
                commit('setListaActiva', res.data.lista);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_METODOS_PAGO_ABONOS_BASE_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.metodos-pago-abonos-abase.update'), data).then(res => {
                commit('setListaActiva', res.data.lista);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_METODOS_PAGO_EVENTOS_UPDATE: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.metodos-pago-eventos.update'), data).then(res => {
                commit('setListaActiva', res.data.lista);
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};
